/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import {
    REMOVE_GRID_ITEMS,
    SET_GRID_COLUMN_LIMIT,
    SET_GRID_FOCUS,
    SET_GRID_ITEM_FOCUS,
    SET_GRID_ITEMS,
    SET_GRID_ROW_LIMIT,
} from './grid.types';
import { IGridEntry } from './gridprops';

export const setGridItemsAction = (id: string, entry: IGridEntry) => ({
    type: SET_GRID_ITEMS,
    payload: { id, entry },
});

export const removeGridItemsAction = (id: string) => ({
    type: REMOVE_GRID_ITEMS,
    payload: { id },
});

export const setGridColumnLimitAction = (id: string, columnLimit: number) => ({
    type: SET_GRID_COLUMN_LIMIT,
    payload: { id, columnLimit },
});

export const setGridRowLimitAction = (id: string, rowLimit: number) => ({
    type: SET_GRID_ROW_LIMIT,
    payload: { id, rowLimit },
});

export const setGridItemFocusAction = (
    id: string,
    focusedItem: { row: number; column: number },
) => ({
    type: SET_GRID_ITEM_FOCUS,
    payload: { id, focusedItem },
});

export const setGridFocusAction = (id: string, isActive: boolean) => ({
    type: SET_GRID_FOCUS,
    payload: { id, isActive },
});
